import {Injectable, Injector} from "@angular/core";
import {ReportError} from "app/app.service";

import {BaseListService} from "app/services/domain/base.service";
import * as Models from "app/services/proxy/model/models";

@Injectable()
export class TransactionLogService extends BaseListService<Models.MasterAccountBillingListTransactionRequest, Models.BatchRequest, Models.MasterAccountBillingTransactionDocument>
{
    constructor(inj: Injector)
    {
        super(inj, Models.MasterAccountBillingTransactionDocument);
    }

    @ReportError
    public list(listReq: Models.MasterAccountBillingListTransactionRequest): Promise<Models.ListResponse>
    {
        return this.domain.apis.masterAccountBilling.billingTransactionsList(listReq);
    }


    @ReportError
    protected async getBatchResponseImpl(req: Models.BatchRequest): Promise<Models.MasterAccountBillingTransactionsBatchResponse>
    {
        const recordIdBatchRequest = Models.BatchRequest.newInstance(req);
        return this.domain.apis.masterAccountBilling.billingTransactionsBatch(recordIdBatchRequest);
    }

    protected createBatchRequest(): Models.BatchRequest
    {
        return Models.BatchRequest.newInstance({ids: []});
    }
}
